import {
  anyContainingPermission,
  withAuthorizationRequired,
} from "portal/components/auth/WithAuthorizationRequired";
import { Header } from "portal/components/header/Header";
import { IconButton, Typography } from "@mui/material";
import { ImplementForm } from "./ImplementForm";
import { Page } from "portal/components/Page";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { FC } from "react";

interface CreateImplementProps {}
export const _CreateImplement: FC<CreateImplementProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Page>
      <Header
        title={t("views.autotractor.equipment.implements.newImplement")}
      />
      <div className="flex flex-col">
        <div className="flex gap-2">
          <IconButton color="info" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" className="my-auto">
            {t("views.autotractor.equipment.implements.newImplement")}
          </Typography>
        </div>
        <ImplementForm />
      </div>
    </Page>
  );
};

export const CreateImplement = withAuthorizationRequired(
  anyContainingPermission(
    PermissionAction.update,
    PermissionResource.atk_equipment,
    PermissionDomain.customer
  ),
  _CreateImplement
);
